import clsx from 'clsx';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuPortal,
  DropdownMenuContent,
  DropdownMenuHeader,
  GhostButton,
  InputSearch,
  ToolButton,
  Tooltip
} from '@bst/react-ui';

type Props = {
  search?: string;
  children: ReactNode;
  setSearch?: (value: string) => void;
  hasNotification?: boolean;
};

/**
 * CellFilter component
 * Returns Button to open dropdown menu and Search input (optional)
 * Children property bust be CellFilterValueList
 */
export const CellFilter = ({
  search,
  children,
  setSearch,
  hasNotification
}: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false)
  const [focused, setFocused] = useState(false);
  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={setIsOpen}
      data-testid="dropdown-menu"
    >
      <DropdownMenuTrigger
        asChild
        data-testid="dropdown-menu-trigger"
      >
        <span className="dropdown-menu-tooltip-wrapper">
          <Tooltip content={t('cellFilterTitle')}>
            <ToolButton
              isActive={isOpen || hasNotification}
              size="small"
              icon="icon-filter"
              className="rdg-filter-button"
            />
          </Tooltip>
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent
          side="left"
          align="start"
          sideOffset={16}
          collisionPadding={8}
          className="bst-ui__dropdown-filter theme-darkMode"
          onFocusOutside={(event) => event.preventDefault()}
          onCloseAutoFocus={(event) => event.preventDefault()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <DropdownMenuHeader>
            <div className="bst-ui__dropdown-filter__header">
              {t("cellFilterTitle")}
              <GhostButton icon="icon-close" onClick={() => setIsOpen(false)} />
            </div>
          </DropdownMenuHeader>
          {setSearch && (
            <InputSearch
              value={search}
              handleInputChange={setSearch}
              onBlur={() => setFocused(false)}
              onFocus={() => setFocused(true)}
              className={clsx((Boolean(search) || focused) && "is-active")}
            />
          )}
          {children}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}